import { queryCache } from "react-query";
import {
  QueryConfig,
  QueryFunction,
  QueryKey,
} from "react-query/types/core/types";

function requestCache<TResult = unknown, TError = unknown>(
  queryKey: QueryKey,
  queryFn: QueryFunction<TResult>,
  queryConfig: QueryConfig<TResult, TError> = { staleTime: 600000 },
): Promise<TResult> {
  return queryCache.fetchQuery(queryKey, queryFn, queryConfig);
}

export default requestCache;
